import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'earthy' | 'forest' | 'air' | 'sea' | 'midnight';
export type ColorMode = 'light' | 'dark';

interface ThemeState {
	theme: Theme;
	colorMode: ColorMode;
	setTheme: (theme: Theme) => void;
	setColorMode: (mode: ColorMode) => void;
	toggleColorMode: () => void;
}

// Apply theme class to body element
const applyThemeClass = (theme: Theme, colorMode: ColorMode) => {
	const body = document.body;
	
	// Remove all existing theme classes
	const themeClasses = [
		'earthy-light', 'earthy-dark',
		'forest-light', 'forest-dark', 
		'air-light', 'air-dark',
		'sea-light', 'sea-dark',
		'midnight-light', 'midnight-dark'
	];
	
	body.classList.remove(...themeClasses);
	
	// Apply the new theme class
	const themeClass = `${theme}-${colorMode}`;
	body.classList.add(themeClass);
	
	console.log(`🎨 Applied theme class: ${themeClass}`);
};

export const useThemeStore = create<ThemeState>()(
	persist(
		(set, get) => ({
			theme: 'earthy',
			colorMode: 'light',

			setTheme: (theme: Theme) => {
				set({ theme });
				const { colorMode } = get();
				applyThemeClass(theme, colorMode);
			},

			setColorMode: (mode: ColorMode) => {
				set({ colorMode: mode });
				const { theme } = get();
				applyThemeClass(theme, mode);
			},

			toggleColorMode: () => {
				const { colorMode } = get();
				const newMode = colorMode === 'light' ? 'dark' : 'light';
				get().setColorMode(newMode);
			},
		}),
		{
			name: 'ekonavi-theme-storage',
			onRehydrateStorage: () => (state) => {
				if (state) {
					// Apply theme class on initial load
					applyThemeClass(state.theme, state.colorMode);
				}
			},
		}
	)
);